import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import Content from "../components/Content";
import CustomInput from "../components/CustomInput";
import { RxCross2 } from "react-icons/rx";
import { useDispatch } from "react-redux";
import { delImg, uploadImg } from "../features/upload/uploadSlice";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { base_url } from "../utils/baseUrl";
import { config } from "../utils/axiosconfig";
import {
  createCategory,
  getCategory,
  updateCategory,
} from "../features/category/category";
import LocaleProvider from "antd/es/locale";
import Loader from "../components/Loader/Loader";

let schema = yup.object().shape({
  title: yup.string().required("Category Name is Required"),
  images: yup.mixed().required("Image is Required"),
});

const Addcat = () => {
  const [previewImage, setPreviewImage] = useState(null);
  const [img, setImg] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [info, setInfo] = useState({});
  const [check, setCheck] = useState(false);
  const [imgID, setImgID] = useState([]);
  const location = useLocation();
  const cID = location.pathname.split("/")[3];
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchInfo = async () => {
      try {
        const response = await getCategory(cID);
        console.log(response, "at the time of update---");
        setInfo(response);
        setImgID([response.images[0].fileName]);
      } catch (error) {
        console.log(error);
      }
    };
    fetchInfo();
  }, [cID]);

  useEffect(() => {
    if (info.images && info.images.length > 0) {
      setPreviewImage(info.images[0].fileUrl);
    }
  }, [info]);

  useEffect(() => {
    if (cID === undefined) {
      setInfo("");
      setPreviewImage("");
      setImg("");
    }
  }, [cID]);

  const formik = useFormik({
    initialValues: {
      title: info.title || "",
      images: info.images || "",
    },
    enableReinitialize: true,
    validationSchema: schema,
    onSubmit: async (values) => {
      try {
        setIsLoading(true);
        if (cID != undefined) {
          if (check) {
            console.log(imgID, "deleting---");
            handleDeleteImage(imgID);
            const imageUrl = await handleImageUpload();
            const formData = {
              ...values,
              images: imageUrl?.payload?.data,
            };
            const response = await updateCategory(cID, formData);
            if (response) {
              toast.success("Category Updated Successfullly!");
              setCheck(false);
              setIsLoading(false);
              navigate("/admin/list-category");
            }
          } else {
            const response = await updateCategory(cID, values);
            if (response) {
              toast.success("Category Updated Successfully!");
              setCheck(false);
              setIsLoading(false);
              navigate("/admin/list-category");
            }
          }
        } else {
          if (values.images) {
            const imageUrl = await handleImageUpload();
            console.log(imageUrl, "inside image");
            const formData = {
              ...values,
              images: imageUrl?.payload?.data,
            };

            const response = await createCategory(formData);
            if (response) {
              toast.success("Category Added Successfullly!");
              navigate("/admin/list-category");
              setIsLoading(false);
            }
          }
        }
      } catch (error) {
        console.log(error);
        setIsLoading(false);
      }
    },
  });

  const handleDeleteImage = async (imgID) => {
    let payload = { data: imgID };
    try {
      const response = await axios.post(
        `${base_url}uploadTo/deleteMultipleDocData`,
        payload,
        config
      );
      formik.setFieldValue("images", []);
      setPreviewImage(null);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  const handleRemoveImage = () => {
    formik.setFieldValue("images", null);
    setPreviewImage(null);
    if (cID != undefined) {
      setCheck(true);
    } else {
      setCheck(false);
    }
  };

  const handleImageUpload = async () => {
    try {
      const imageUrl = await dispatch(uploadImg(img));
      return imageUrl;
    } catch (error) {
      console.error("Image upload failed:", error);
      throw error;
    }
  };

  const handleFileChange = (event) => {
    const file = event.currentTarget.files[0];
    setImg([file]);
    formik.setFieldValue("images", file);
    setPreviewImage(URL.createObjectURL(file));
  };

  return (
    <Content>
      {isLoading ? <Loader open={isLoading} /> : ""}
      <div>
        <h4 className="mb-4 title">
          {cID !== undefined ? "Edit" : "Add"} Category
        </h4>
        <form onSubmit={formik.handleSubmit}>
          <CustomInput
            type="text"
            label="Enter Category Name"
            id="title"
            name="title"
            onChng={formik.handleChange}
            onBlr={formik.handleBlur}
            val={formik.values.title}
          />
          {formik.touched.title && formik.errors.title ? (
            <div className="error">{formik.errors.title}</div>
          ) : null}

          <div className="mt-3">
            <label htmlFor="images" className="form-label">
              {cID != undefined ? "Edit" : "Add"} Category Icon
            </label>
            <div className="p-4 d-flex align-items-center justify-content-center bg-light">
              {previewImage ? (
                <div className=" position-relative">
                  <div>
                    <img
                      src={previewImage}
                      alt="Preview"
                      style={{ maxWidth: "200px", maxHeight: "200px" }}
                    />
                    <span
                      className="position-absolute text-danger top-0 end-0 rounded-circle "
                      style={{ cursor: "pointer" }}
                      onClick={handleRemoveImage}
                    >
                      <RxCross2 size={22} />
                    </span>
                  </div>
                </div>
              ) : (
                <div className="d-flex align-items-center justify-content-center flex-column">
                  <p className="text-muted mb-2">Drop files here to upload</p>
                  <label htmlFor="images" className="btn btn-primary">
                    Upload file
                    <input
                      type="file"
                      id="images"
                      name="images"
                      className="d-none"
                      onChange={handleFileChange}
                      accept="image/*"
                    />
                  </label>
                </div>
              )}
            </div>
          </div>
          {formik.touched.images && formik.errors.images ? (
            <div className="error">{formik.errors.images}</div>
          ) : null}

          <div className="d-flex justify-content-end">
            <button
              className="btn btn-primary border-0 rounded-3 my-5"
              type="submit"
            >
              {cID != undefined ? "Update" : "Add"} Category
            </button>
          </div>
        </form>
      </div>
    </Content>
  );
};

export default Addcat;
